
    import { sdk } from 'https://esm.sh/@farcaster/miniapp-sdk';

    async function initBaseApp() {
      await new Promise(r => (document.readyState==='loading'
        ? document.addEventListener('DOMContentLoaded', r, {once:true}) : r()));

      document.documentElement.setAttribute('data-host','base');

      let isMini = false;
      try {
        const p = sdk.actions.ready({ disableNativeGestures: true });
        await Promise.race([p, new Promise(r => setTimeout(r, 800))]);
        isMini = await sdk.isInMiniApp();
      } catch (err) {
        console.error('BASE_INIT_ERR', err);
      }

      // 1) Provider nativo do Base App (EIP-1193) + shim em window.ethereum (para wagmi/viem)
      let baseProvider = null;
      if (isMini) {
        try {
          baseProvider = await sdk.wallet.getEthereumProvider();
          // Se seu app espera window.ethereum, injeta:
          if (!window.ethereum) window.ethereum = baseProvider;
          // Dica opcional: fixe a chain (Base mainnet = 8453) se seu app não fizer isso
          try { await baseProvider.request?.({ method: 'wallet_switchEthereumChain', params: [{ chainId: '0x2105' }] }); } catch {}
        } catch (e) {
          console.warn('No Base EIP-1193 provider', e);
        }
      }


      // 4) Marcas úteis (se seu CSS usa .app-ready no body tbm)
      document.documentElement.classList.add('app-ready');
      document.body.classList.add('app-ready');


      // 6) Exponha para o bundle, se ele chamar direto
      window.__HOST__ = 'base';
      window.__IS_MINI__ = false; // Será atualizado pela função createStripeButton
      
      // Funções para detectar Base Host e acessar Base Wallet
      window.isBaseHost = () =>
        (typeof window !== 'undefined') &&
        (window.__HOST__ === 'base' || document.documentElement.getAttribute('data-host') === 'base');

      window.baseWallet = () => (window.isBaseHost() ? window.__BASE_WALLET__ : null);
    }

    initBaseApp();
  